import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

const Undermaintanence = ({ modalOpen }) => {

  

    return (
        <Modal isOpen={modalOpen} centered="true" className="mymodal Undermaintanence" backdropClassName="modalbackbg">
            <ModalHeader ></ModalHeader>
            <ModalBody>
                    <div className='text-center'>
                        <div className="mt-n3"><img src={require('../../assets/images/websitesetup.png')} alt='websitesetup' className='img-fluid' /></div>
                        <div className='modal-title mt-4 mb-4'>The site is on improvisation</div>
                    </div>

            </ModalBody>
        </Modal>
    )
}
Undermaintanence.propTypes = {
    modalOpen: PropTypes.any.isRequired,
};
export default Undermaintanence;